import { HostID } from '@common/types/HostID';
import { ThemeID } from '@common/types/ThemeID';
import { getHostByHostname, Host } from '@common/utils/HostUtil';

export const hostHostIDMap: Record<Host, HostID> = {
    [Host.AB]: HostID.AB,
    [Host.BI]: HostID.BI,
    [Host.BR]: HostID.BR,
    [Host.MH]: HostID.MH,
    [Host.RW]: HostID.RW,
    [Host.VI]: HostID.VI,
    [Host.VN]: HostID.VN,
    [Host.VP]: HostID.VP,
    [Host.VP_BE]: HostID.VPBE,
    [Host.WH]: HostID.WH,
};

const hostThemeIDMap: Record<Host, ThemeID> = {
    [Host.AB]: ThemeID.AB,
    [Host.BI]: ThemeID.BI,
    [Host.BR]: ThemeID.BR,
    [Host.MH]: ThemeID.MH,
    [Host.RW]: ThemeID.RW,
    [Host.VI]: ThemeID.VI,
    [Host.VN]: ThemeID.VN,
    [Host.VP]: ThemeID.VP,
    [Host.VP_BE]: ThemeID.VPBE,
    [Host.WH]: ThemeID.WH,
};

const DEFAULT_THEME = ThemeID.VP;

export const getTheme = (hostname: string, excludeAdmin?: boolean): ThemeID => {
    if (!hostname) {
        return DEFAULT_THEME;
    }

    const host = getHostByHostname(hostname);

    if (!host) {
        return DEFAULT_THEME;
    }

    if (!excludeAdmin) {
        const isAdminEnv = hostname.match(/admin/);

        if (isAdminEnv) {
            return ThemeID.ADMIN;
        }
    }

    return hostThemeIDMap[host];
};

export const getThemeClass = (themeID: ThemeID): string => `theme-${themeID}`;
